import { useMemo, useRef } from 'react';

import * as authApi from '../services/authApi';
import * as capabilitiesApi from '../services/capabilitiesApi';
import * as meetingApi from '../services/meetingApi';
import * as preferencesApi from '../services/preferencesApi';
import { getUserFriendlyError } from '../utils/errors';
import { useAuth } from './useAuth';

// Web's implementation of @copilot/ui's SettingsApi. Stable for the
// component's lifetime (a new object would make every shared section
// reload), while still refreshing the signed-in user after a preferences
// save so every screen sees it. PATCH /api/users/me/preferences merges,
// so each section sends only its own fields.
export function useSettingsApi() {
  const { updateUser } = useAuth();
  const updateUserRef = useRef(updateUser);
  updateUserRef.current = updateUser;

  return useMemo(
    () => ({
      getAiPreferences: () => preferencesApi.getPreferences(),
      updateAiPreferences: (next) => preferencesApi.updatePreferences(next),
      async updatePreferences(next) {
        const user = await authApi.updatePreferences(next);
        updateUserRef.current(user);
        return user;
      },
      getLanguageCapabilities: () => capabilitiesApi.getLanguageCapabilities(),
      async getRecentMeetings() {
        const page = await meetingApi.listMeetings({ page: 1, pageSize: 25 });
        return page.items || [];
      },
      describeError: (error, fallback) => getUserFriendlyError(error, fallback),
    }),
    []
  );
}
